// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"842":"a94edea58437ccb0","888":"b037b87a00b76bcd"}[chunkId] + ".css";
};